var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenpdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L14.0625 3.65909L11.25 0Z",
    fill: "#0AC963"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.2383V18.8178H13.5V11.2383H4.5ZM8.4375 17.7724H5.625V16.4656H8.4375V17.7724ZM8.4375 15.6815H5.625V14.3746H8.4375V15.6815ZM8.4375 13.5906H5.625V12.2837H8.4375V13.5906ZM12.375 17.7724H9.5625V16.4656H12.375V17.7724ZM12.375 15.6815H9.5625V14.3746H12.375V15.6815ZM12.375 13.5906H9.5625V12.2837H12.375V13.5906Z",
    fill: "#0AC963"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7436 5.81445L18 11.6272V6.27315L11.7436 5.81445Z",
    fill: "url(#paint0_linear_5791_17960)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0V4.70455C11.25 5.57097 12.0052 6.27273 12.9375 6.27273H18L11.25 0Z",
    fill: "#87CEAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 0C0.759375 0 0 0.705682 0 1.56818V1.69886C0 0.836364 0.759375 0.130682 1.6875 0.130682H11.25V0H1.6875Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 22.869H1.6875C0.759375 22.869 0 22.1633 0 21.3008V21.4315C0 22.294 0.759375 22.9996 1.6875 22.9996H16.3125C17.2406 22.9996 18 22.294 18 21.4315V21.3008C18 22.1633 17.2406 22.869 16.3125 22.869Z",
    fill: "#263238",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5791_17960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5791_17960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 6.27326C12.0052 6.27326 11.25 5.5715 11.25 4.70508V4.83576C11.25 5.70218 12.0052 6.40394 12.9375 6.40394H18V6.27326H12.9375Z",
    fill: "#263238",
    fillOpacity: 0.1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H1.6875C0.759375 0 0 0.705682 0 1.56818V21.4318C0 22.2943 0.759375 23 1.6875 23H16.3125C17.2406 23 18 22.2943 18 21.4318V6.27273L11.25 0Z",
    fill: "url(#paint1_radial_5791_17960)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93065 11.7726C4.97926 11.7308 5.0862 11.6611 5.16883 11.6239C5.30007 11.5589 5.70352 11.5496 8.67832 11.5449C11.9496 11.5449 12.0517 11.5496 12.2413 11.6378C12.3482 11.6889 12.4746 11.7865 12.5281 11.8608C12.5767 11.9305 12.6447 12.0699 12.6739 12.1721C12.7079 12.2929 12.7273 13.0177 12.7273 14.286C12.7273 15.5543 12.7079 16.2791 12.6739 16.3999C12.6447 16.5021 12.5718 16.6461 12.5135 16.7204C12.46 16.7994 12.3239 16.897 12.217 16.9434C12.0371 17.0178 11.7844 17.0271 8.70748 17.0271C5.8056 17.0271 5.36326 17.0178 5.20772 16.9527C5.10564 16.9156 4.97926 16.8459 4.93065 16.8041C4.88205 16.7623 4.79941 16.6415 4.75081 16.5393C4.66817 16.3674 4.65845 16.1955 4.65845 14.286C4.65845 12.3765 4.66817 12.2046 4.75081 12.0327C4.79941 11.9305 4.88205 11.8144 4.93065 11.7726Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89309 12.4474C6.96115 12.4056 7.0778 12.3452 7.16044 12.3173C7.24307 12.2894 7.35973 12.2662 7.42778 12.2662C7.49583 12.2616 7.62707 12.2848 7.71943 12.3127C7.81178 12.3452 7.94302 12.4102 8.01107 12.4567C8.07912 12.5078 8.1812 12.624 8.23953 12.7169C8.3173 12.8377 8.35133 12.9631 8.35133 13.135C8.35133 13.2651 8.32702 13.4323 8.29786 13.5067C8.27356 13.5764 8.19092 13.6925 8.11801 13.7668C8.0451 13.8412 7.91386 13.9294 7.83123 13.962C7.74373 13.9991 7.56388 14.027 7.42778 14.027C7.29654 14.027 7.12641 13.9991 7.0535 13.962C6.97573 13.9294 6.84935 13.8272 6.76671 13.7436C6.68894 13.6553 6.59173 13.502 6.5577 13.3998C6.51881 13.2837 6.50423 13.1443 6.52368 13.0281C6.54312 12.9259 6.60631 12.7726 6.66464 12.6844C6.72297 12.5961 6.82504 12.4892 6.89309 12.4474Z",
    fill: "#0AC963"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74373 15.6066C7.87011 15.6066 8.05968 15.444 9.10475 14.4451L10.3199 13.2837L12.3372 15.2117V15.5834C12.3372 15.8389 12.3129 15.9876 12.1913 16.1641H5.58068L5.50777 16.0619C5.46889 16.0015 5.43486 15.904 5.43486 15.8389C5.43486 15.7553 5.58068 15.5834 5.97927 15.2024C6.28064 14.9144 6.54798 14.6774 6.57714 14.6774C6.60145 14.6774 6.84449 14.8865 7.11183 15.142C7.51041 15.523 7.62221 15.6066 7.74373 15.6066Z",
    fill: "#0AC963"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5791_17960",
    x1: 324.598,
    y1: 55.7231,
    x2: 324.598,
    y2: 587.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5791_17960",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0249 45.4581) scale(2902.47 2697.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenpdf);
export default __webpack_public_path__ + "static/media/greenpdf.d4ee7d98ea8be5f799b592d333ac8bdd.svg";
export { ForwardRef as ReactComponent };